export { default as CardService } from './CardService'
